import Vue from 'vue';
import router from './router';
import App from './App.vue';
import pwaService from "./Services/pwaService";
import env from "env";
Vue.config.productionTip = true

if (window.VCONSOLE_ENABLE) {
    import(
        /* webpackChunkName: "vconsole" */
        /* webpackMode: "lazy" */
        "vconsole")
        .then((module) => {
            const VConsole = module.default || module;
            new VConsole();
        })
}



new Promise((resolve) => {
    if (global.NAMESPACE === "glorious") {
        import(
            /* webpackChunkName: "vue-gtag" */
            /* webpackMode: "lazy" */
            "vue-gtag")
            .then((module) => {
                const VueGtag = module.default || module;
                Vue.use(VueGtag, {
                    config: { id: "G-B6C0V7ZMSD" }
                }, router);
                resolve()
            })
    } else {
        resolve()
    }
})
.then(() => {
    new Vue({
        router,
        render: h => h(App),
    }).$mount('#app')
});

if (env.ENABLE_PWA) {
    pwaService.installServiceWorker();
    pwaService.addPWAInstaller();
} else {
    pwaService.uninstallServiceWorker();
}





